<template>
  <x-page title="取消订单">
    <x-result
      title="订单取消成功"
      confirm-text="订单列表"
      guess-resource-position-id="8aaa92be7b66c738017b77a0149900c8"
      :confirm-track="{
        name: '取消订单-订单列表',
        id: 'fc604888-cfee-4526-870f-b7e50123e5e1',
      }"
      @confirm="handleConfirmClick"
    />
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { navigateBack } from '@/router'
  import { Track } from '@/utils'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      Track.provideMark(() => ({
        page: '订单取消成功',
      })),
    ],

    methods: {
      // 点击订单列表
      handleConfirmClick() {
        navigateBack()
      },
    },
  })
</script>

<style lang="scss" scoped></style>
